import * as React from "react";

const OptionsIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    id="fi_5718983"
    width="512"
    height="512"
    data-name="Layer 1"
    viewBox="0 0 32 32"
  >
    <circle cx="16" cy="5" r="3"></circle>
    <circle cx="16" cy="16" r="3"></circle>
    <circle cx="16" cy="27" r="3"></circle>
  </svg>
);

export default OptionsIcon;
